import type { ChangeEvent } from 'react'
import { Text } from '~/components/typography'
import './multi-switch.css'
import { cn } from '~/util'

export type MultiSwitchOptionProps<T = string> = {
  title: string
  value: T
  position: string
  getSwitchAnimation?: (value: string | number) => void
  switchPosition?: string
  groupName?: string
}

function MultiSwitchOption<T = string>({
  title,
  position,
  switchPosition,
  getSwitchAnimation,
  groupName = 'map-switch',
}: MultiSwitchOptionProps<T>) {
  const checked = position === switchPosition
  const inputId = groupName ? `${groupName}-${position}` : position
  return (
    <>
      <input
        onChange={(e: ChangeEvent<HTMLInputElement>) => getSwitchAnimation?.(e.target.value)}
        name={groupName}
        id={inputId}
        type="radio"
        value={position}
        checked={checked}
        aria-describedby={`${inputId}-label`}
        tabIndex={-1}
      />
      <label
        className={cn('mt-0.5', `${position}-label`, checked ? 'z-10 bg-blue-500' : 'z-0 bg-none')}
        htmlFor={inputId}
        id={`${inputId}-label`}
        role="radio"
        aria-checked={checked}
        aria-label={title}
      >
        <Text className={checked ? 'text-neutral-white' : 'text-blue-500'} level={4}>
          {title}
        </Text>
      </label>
    </>
  )
}

export default MultiSwitchOption
